import {
  buildPermissionMap,
  canStayOnModule,
  firstAllowedHome,
  rolesFromUser,
} from '../../assets/utils/permissions';

export const REMEMBER_USERNAME_KEY = 'care_admin_remember_username';
export const SESSION_EXPIRED_REASON = 'session_expired';

export function getEnvironmentBadge() {
  const env = (process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development').toLowerCase();

  if (env === 'production') {
    return null;
  }
  if (env === 'staging') {
    return { label: 'Staging', color: 'processing' };
  }
  if (env === 'development' || env === 'local') {
    return { label: 'Local', color: 'warning' };
  }
  return { label: env, color: 'default' };
}

export function resolvePostLoginRoute(user) {
  const rawPerms = user?.profile?.permissions;
  const permMap = Array.isArray(rawPerms)
    ? buildPermissionMap({ permissions: rawPerms })
    : (user?.permissions && typeof user.permissions === 'object' ? user.permissions : {});

  const home = firstAllowedHome(permMap, rolesFromUser(user));
  if (home) return home;

  // firstAllowedHome only returns null when the RBAC map is empty, so this is the
  // legacy landing table. Plain helper (no hook available) — the pure four-arg form of
  // canStayOnModule keeps the legacy ids as data and applies them only on an empty map.
  if (canStayOnModule('staffManagement', permMap, user, [1])) {
    return { path: '/dash', label: 'Staff management' };
  }
  if (canStayOnModule('dashboard', permMap, user, [2, 3, 4, 5])) {
    return { path: '/dashboard', label: 'Dashboard' };
  }
  if (canStayOnModule('clientVerification', permMap, user, [6, 7, 8, 9])) {
    return { path: '/verify', label: 'Verification' };
  }

  return { path: '/dashboard', label: 'Dashboard' };
}

export function readRememberedUsername() {
  try {
    return localStorage.getItem(REMEMBER_USERNAME_KEY) || '';
  } catch {
    return '';
  }
}

export function persistRememberedUsername(username, remember) {
  try {
    if (remember && username) {
      localStorage.setItem(REMEMBER_USERNAME_KEY, username);
    } else {
      localStorage.removeItem(REMEMBER_USERNAME_KEY);
    }
  } catch {
    /* ignore storage errors */
  }
}
